module.exports = __webpack_public_path__ + "static/media/suzuki.29453b3a.png";